import { getDateDescription } from 'flow/utils';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    date: string;
    bgClassName?: string;
}

const DateSectionHeader = ({ date, bgClassName }: Props) => {
    const { i18next } = useAppContext();
    const bg = twMerge('bg-white', bgClassName);

    // 48px row = 24px divider item + 12px transparent padding top/bottom.
    // The opaque sticky background covers only the top half of the item —
    // down to the gray line — so content scrolling under a pinned divider
    // is masked above the line but stays visible right up to it, and
    // everything below the line (and the padding) stays see-through; only
    // the label chip is opaque around the text. Sticking at top:-12px
    // scrolls the top padding off-screen as it pins, so the item sits
    // flush at the top when stuck while keeping its distance from items
    // above in the list.
    return (
        <div className="sticky -top-3 z-10 flex h-12 w-full items-center py-3">
            <div className="relative flex h-6 w-full items-center">
                <div
                    className={twMerge(
                        'absolute inset-x-0 top-0 bottom-1/2',
                        bg,
                    )}
                />
                <div className="absolute start-0 top-1/2 z-0 h-px w-full bg-gray-200" />
                <div className="relative flex w-full justify-center">
                    <span
                        className={twMerge(
                            'relative rounded px-3 text-xs font-bold text-gray-700 antialiased',
                            bg,
                        )}
                    >
                        {getDateDescription(date, i18next)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default DateSectionHeader;
